export default __webpack_public_path__ + "static/media/salvalandingpage.635f1a64.PNG";